// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__00G8o","logo_img":"Logo_logo_img__ofSkU"};